import React from "react";
import MyAccountTab from "./MyAccountTab";
import CashierTab from "./CashierTab";
import CouponTab from "./CouponTab";
import RefundTab from "./RefundTab";
import BonusTab from "./BonusTab";
import ReferFriendTab from "./ReferFriendTab";
import AutoPromoTab from "./AutoPromoTab";
import WheelSpinTab from "./WheelSpinTab";
import ReviewTab from "./ReviewTab";

export const menuTabs = [
  {
    id: "deposit",
    label: "ฝากเงิน",
    desc: "เลือกช่องทางและระบุจำนวนเงินเพื่อเติมเครดิต",
    icon: "solar:card-recive-bold-duotone",
    component: () => <CashierTab initialTab="deposit" hideTabs />,
    group: "wallet",
  },
  {
    id: "withdraw",
    label: "ถอนเงิน",
    desc: "แจ้งถอนเข้าบัญชีที่ท่านผูกไว้",
    icon: "solar:card-send-bold-duotone",
    component: () => <CashierTab initialTab="withdraw" hideTabs />,
    group: "wallet",
  },
  {
    id: "cashtocredit",
    label: "แลกกระเป๋าเงินสด",
    shortLabel: "เงินสด > เครดิต",
    desc: "เปลี่ยนเงินสดในกระเป๋าเป็นเครดิตสำหรับเล่นเกม",
    icon: "solar:refresh-circle-bold-duotone",
    component: () => <CashierTab initialTab="cashtocredit" hideTabs />,
    group: "wallet",
  },
  {
    id: "history",
    label: "ประวัติธุรกรรม",
    shortLabel: "ประวัติ",
    desc: "ตรวจสอบรายการฝาก-ถอนย้อนหลังได้ที่นี่",
    icon: "solar:history-bold-duotone",
    component: () => <CashierTab initialTab="history" hideTabs />,
    group: "wallet",
  },
  {
    id: "autoPromo",
    label: "ตั้งค่าโปรโมชั่น",
    shortLabel: "โปรโมชั่น",
    desc: "เลือกโปรโมชั่นที่ต้องการรับอัตโนมัติเมื่อฝากเงิน",
    icon: "solar:gift-bold-duotone",
    component: AutoPromoTab,
    group: "promotion",
  },
  {
    id: "coupon",
    label: "เครดิตโค้ด",
    shortLabel: "เติมโค้ด",
    desc: "กรอกรหัสคูปองเพื่อรับเครดิต, เพชร ฟรี",
    icon: "solar:ticket-sale-bold-duotone",
    component: CouponTab,
    group: "promotion",
  },
  {
    id: "refund",
    label: "คืนยอดเสีย",
    desc: "ตรวจสอบและกดรับยอดเสียคืน",
    icon: "solar:hand-money-bold-duotone",
    component: RefundTab,
    group: "promotion",
  },
  {
    id: "wheelspin",
    label: "กงล้อพารวย",
    desc: "สะสมเพชรเพื่อหมุนรับของรางวัล",
    icon: "solar:wheel-bold-duotone",
    component: WheelSpinTab,
    group: "activity",
  },
  {
    id: "bonus",
    label: "แรงค์กิ้ง",
    shortLabel: "จัดอันดับ",
    desc: "สะสมยอดฝากเพื่อปลดล็อกสิทธิพิเศษทุกระดับ",
    icon: "solar:cup-star-bold-duotone",
    component: BonusTab,
    group: "activity",
  },
  {
    id: "refer",
    label: "แนะนำเพื่อน",
    desc: "แชร์ลิงก์ให้เพื่อนสมัคร รับโบนัสทุกคนที่เข้าร่วม",
    icon: "solar:users-group-two-rounded-bold-duotone",
    component: ReferFriendTab,
    group: "activity",
  },
  {
    id: "review",
    label: "รีวิว",
    desc: "แบ่งปันความคิดเห็นของคุณกับเรา",
    icon: "solar:star-shine-bold-duotone",
    component: ReviewTab,
    group: "activity",
  },
  {
    id: "account",
    label: "บัญชีของฉัน",
    shortLabel: "ตั้งค่า",
    desc: "ข้อมูลสมาชิกและบัญชีธนาคารของคุณ",
    icon: "solar:user-id-bold-duotone",
    component: MyAccountTab,
    group: "profile",
  },
  {
    id: "contact",
    label: "ติดต่อเรา",
    shortLabel: "ติดต่อ",
    icon: "solar:chat-round-call-bold-duotone",
    component: null,
    group: "profile",
  },
];

export const menuSections = [
  { id: "wallet", label: "การเงิน" },
  { id: "promotion", label: "โปรโมชั่น" },
  { id: "activity", label: "กิจกรรม" },
  { id: "profile", label: "บัญชี" },
];
